// extracted by mini-css-extract-plugin
export default {"headerBar":"TechnicalHelp_headerBar__oGtt0"};